import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, Search, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-4 py-16"
      style={{ backgroundColor: '#E8E0D5' }}
      data-testid="not-found-page"
    >
      <div className="max-w-2xl w-full text-center">
        <div
          className="mx-auto mb-8 flex items-center justify-center"
          style={{
            width: 128,
            height: 128,
            borderRadius: '50%',
            background: 'radial-gradient(circle at 30% 30%, #F5EDE4 0%, #E8D8C4 100%)',
            boxShadow: '0 6px 24px rgba(93, 78, 60, 0.15)',
          }}
        >
          <span
            className="font-light"
            style={{
              fontSize: 72,
              color: '#5D4E3C',
              letterSpacing: '0.05em',
              lineHeight: 1,
            }}
          >
            404
          </span>
        </div>

        <div
          className="mb-3 text-xs uppercase"
          style={{ letterSpacing: '4px', color: '#8B7355' }}
        >
          Verirrt im Zauberwald
        </div>

        <h1
          className="mb-5 font-light"
          style={{
            fontSize: 'clamp(28px, 5vw, 42px)',
            color: '#5D4E3C',
            letterSpacing: '0.02em',
            lineHeight: 1.15,
          }}
        >
          Diese Seite konnten wir<br />leider nicht finden.
        </h1>

        <p
          className="mx-auto mb-10 max-w-lg"
          style={{ color: '#6B5D4F', lineHeight: 1.7, fontSize: 16 }}
        >
          Vielleicht ist der Link etwas älter, oder das Produkt hat unser Zuhause
          bereits verlassen. Kein Grund zur Sorge — im Shop warten viele weitere
          handgemachte Schätze auf dich.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="w-full sm:w-auto">
            <Button
              className="rounded-none w-full sm:w-auto px-8 py-6 text-white"
              style={{ backgroundColor: '#5D4E3C', letterSpacing: '2px', fontSize: 12, textTransform: 'uppercase' }}
              data-testid="notfound-home-btn"
            >
              <HomeIcon className="mr-2 h-4 w-4" />
              Zur Startseite
            </Button>
          </Link>
          <Link to="/products" className="w-full sm:w-auto">
            <Button
              variant="outline"
              className="rounded-none w-full sm:w-auto px-8 py-6"
              style={{ borderColor: '#5D4E3C', color: '#5D4E3C', letterSpacing: '2px', fontSize: 12, textTransform: 'uppercase' }}
              data-testid="notfound-shop-btn"
            >
              <Search className="mr-2 h-4 w-4" />
              Zum Shop
            </Button>
          </Link>
        </div>

        <div className="mt-12 text-sm" style={{ color: '#8B7355' }}>
          Du suchst etwas Bestimmtes?{' '}
          <Link to="/contact" className="inline-flex items-center gap-1 underline" style={{ color: '#5D4E3C' }} data-testid="notfound-contact-link">
            <Mail className="h-3.5 w-3.5" />
            Schreib uns kurz
          </Link>
          .
        </div>
      </div>
    </div>
  );
}
